import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
    Card, Form, Col, Input, Select,
} from 'antd';
import { Link } from 'react-router-dom';
import { SFButton } from '../../../../components/SF-UI';
import { statics } from '../../BikeManagement/components/statics';
import { addLocationCriteriaRequest } from '../redux/actions/add_location_criteria.actions';
import { getLeadOMConfigRequest } from '../../Lead-o-matic_update/redux/actions/get_leadomatic_config.actions';

const mapStateToProps = state => ({ leadomaticConfig: state.PlatformManagement.Lead_o_matic_update });
const FormItem = Form.Item; const
    { Option } = Select;

export default connect(mapStateToProps, null)(class AddAdjustLocation extends PureComponent {
    state = {
        name: '',
        postcode: '',
        priority: '',
        radius: '',
        latitude: '',
        longitude: [],
    };

    componentDidMount() {
        this.props.dispatch(getLeadOMConfigRequest());
    }

    addLocationHandler = (event, data) => {
        typeof event === 'string'
            ? this.setState({ [data.props.name]: event })
            : this.setState({ [event.target.name]: event.target.value });
    };

    submitForm = () => this.props.dispatch(addLocationCriteriaRequest(this.props.leadomaticConfig.config._id, this.state));

    render() {
        return (
            <Col span={10}>
                <Card className="border-shadows">
                    <Form>
                        <FormItem label="Location Name">
                            <Input
                                allowClear
                                autoComplete="off"
                                name="name"
                                placeholder="Enter location name"
                                onChange={this.addLocationHandler}
                            />
                        </FormItem>
                        <FormItem label="Postcode">
                            <Input
                                allowClear
                                autoComplete="off"
                                name="postcode"
                                placeholder="Enter Postcode"
                                onChange={this.addLocationHandler}
                            />
                        </FormItem>
                        <FormItem label="Priority">
                            <Select
                                allowClear
                                autoComplete="off"
                                name="priority"
                                placeholder="Choose Priority"
                                onChange={this.addLocationHandler}
                            >
                                {statics.bike_priorities.map(pr => <Option key={pr.label} name="priority">{pr.value}</Option>)}
                            </Select>
                        </FormItem>
                        <FormItem label="Radius">
                            <Input
                                allowClear
                                autoComplete="off"
                                name="radius"
                                type="number"
                                placeholder="Enter radius"
                                onChange={this.addLocationHandler}
                            />
                        </FormItem>
                        <FormItem label="Latitude">
                            <Input
                                allowClear
                                autoComplete="off"
                                name="latitude"
                                type="number"
                                placeholder="Enter latitude"
                                onChange={this.addLocationHandler}
                            />
                        </FormItem>
                        <FormItem label="Longitude">
                            <Input
                                allowClear
                                autoComplete="off"
                                name="longitude"
                                type="number"
                                placeholder="Enter longitude"
                                onChange={this.addLocationHandler}
                            />
                        </FormItem>
                    </Form>
                    <div className="sf-btn-toolbar">
                        <SFButton>
                            <Link to="/PlatformManagement/Lead-o-matic_update">Back</Link>
                        </SFButton>
                        <SFButton type="primary" style={{ marginLeft: 20 }} onClick={this.submitForm}>Add Location</SFButton>
                    </div>
                </Card>
            </Col>
        );
    }
});



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Lead-o-matic_location_create/components/AddAdjustLocation.js